import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../../shared/services/shared.service';
import { FieldValue, UserType } from '../../shared/constants/services.enum';
import { Utils } from '../../Utils/utils';

@Injectable({ providedIn: 'root' })
export class AccessGuard implements CanActivate {
    private readonly blockedMemberAccountStatuses = ['Cancelled', 'Inactive', 'InProgress', 'Suspended', 'Hold', 'Rejected'];

    constructor(private sharedService: SharedService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        //sessionStorage.removeItem("srNumber");
        let userAccount: any = this.sharedService.getPrimaryAccount();
        const hasSrNumberInUrl = route.pathFromRoot.some((r: ActivatedRouteSnapshot) => !!r.paramMap.get('sr_no'));
        const pageType = route.data['type'];
        // let servicesName = ['registration', 'cancellation', 'amendment', 'renew', 'signatories', 'company-information', 'chamber-entrepreneur'];
        let servicesName = ['registration', 'company-information', 'chamber-entrepreneur'];
        if (servicesName.includes(pageType)) {
            return true;
        } else {
            let accountLicenseType = userAccount && userAccount['DC License Type'];
            if (
                (accountLicenseType === FieldValue.OFFSHORE_LICENSE ||
                accountLicenseType === FieldValue.OFFSHORE_LICENSE_AR) &&
                pageType !== 'amendment' &&
                pageType !== 'renew' &&
                pageType !== 'cancellation'
            ) {
                this.sharedService.toastMessage('INFO', 'OFFSHORE_LICENSE_NOTALLOWED', 'info', true);
                return false;
            }
            if (userAccount && (userAccount["Account Type Code"] == UserType.MEMBER
                || userAccount["Account Type Code"] == UserType.MEMBER_AR)
            ) {
                if (!userAccount["DC Expiry Date"]) {
                    this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info', true);
                    return false;
                }
                let isMemberShipValid: any = Utils.isMembershipValid(userAccount["DC Expiry Date"])
                if (!isMemberShipValid && !hasSrNumberInUrl && pageType != 'renew' && pageType != 'cancellation') {
                    this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info', true);
                    return false;
                }
                if (this.hasBlockedMemberAccountStatus(userAccount)) {
                    this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info', true);
                    return false;
                }
            }
            return true;
        }
    }

    private hasBlockedMemberAccountStatus(member: any): boolean {
        const accountStatus = (member?.['Account Status'] || '').toString().trim();
        return this.blockedMemberAccountStatuses.includes(accountStatus);
    }
}
